import apiService from "../../api/api.service";
import { NewsletterPayload, NewsletterResponse } from "./newsletter.types";

export const subscribeNewsletter = (data: NewsletterPayload) => {
  return apiService.post<NewsletterResponse>("/general/newsletters", data);
};
